export default __webpack_public_path__ + "static/media/people1full.8195a0ce.jpg";